// MuteButton.js
'use strict';
import { connect } from 'react-redux';

import MuteButton from '../component/MuteButton.jsx';

import setPlayerData from '../action/setPlayerData.js';

import getOperationData from '../selector/getOperationData.js';

const mapStateToProps = state => {
  return {
    isMuted: getOperationData(state, ['player'], 'isMuted'),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMute: isMuted =>
      dispatch(setPlayerData({ isMuted, isFirstUnmuted: false })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MuteButton);
